import * as Yup from 'yup'
import { toDateTimeLocalInput } from '../../../../../../util/date.util'

export const SCHEDULE_TYPES = {
  SCHEDULE: 'SCHEDULE',
  NOW: 'NOW',
}

export const FORM_FIELDS = {
  SCHEDULE_TYPE: 'scheduleType',
  SCHEDULED_DATE: 'scheduledDate',
  ALERT_ON_SUCCESS: 'alertOnSuccess',
  ALERT_ON_FAILURE: 'alertOnFailure',
}

export const INITIAL_VALUES = {
  [FORM_FIELDS.SCHEDULE_TYPE]: SCHEDULE_TYPES.NOW,
  [FORM_FIELDS.SCHEDULED_DATE]: '',
  [FORM_FIELDS.ALERT_ON_SUCCESS]: true,
  [FORM_FIELDS.ALERT_ON_FAILURE]: true,
}

export const FIELDS_TO_VALIDATE = {
  [FORM_FIELDS.SCHEDULE_TYPE]: true,
  [FORM_FIELDS.SCHEDULED_DATE]: true,
  [FORM_FIELDS.ALERT_ON_SUCCESS]: true,
  [FORM_FIELDS.ALERT_ON_FAILURE]: true,
}

export const getValidationSchema = (intl) => {
  const requiredMessage = intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })
  const startDateValidationMessage = intl.formatMessage({ id: 'VALIDATION.START_TIME_GT_CURRENT_TIME' })

  return Yup.object().shape({
    [FORM_FIELDS.SCHEDULE_TYPE]: Yup.string(),
    [FORM_FIELDS.SCHEDULED_DATE]: Yup.date().when(FORM_FIELDS.SCHEDULE_TYPE, {
      is: SCHEDULE_TYPES.SCHEDULE,
      then: () => Yup.date().required(requiredMessage).min(new Date(), startDateValidationMessage),
    }),
  })
}

export const isScheduleSelected = (values) => values[FORM_FIELDS.SCHEDULE_TYPE] === SCHEDULE_TYPES.SCHEDULE

// parse form values to api payload format
export const toApiPayload = (values) => {
  if (!isScheduleSelected(values)) {
    return null
  }

  return {
    start_time: new Date(values[FORM_FIELDS.SCHEDULED_DATE]).toISOString(),
    success_alert_enabled: values[FORM_FIELDS.ALERT_ON_SUCCESS],
    failure_alert_enabled: values[FORM_FIELDS.ALERT_ON_FAILURE],
  }
}

// parse api data to form values format
export const toFormValues = (payload) => ({
  [FORM_FIELDS.SCHEDULE_TYPE]: SCHEDULE_TYPES.SCHEDULE,
  [FORM_FIELDS.SCHEDULED_DATE]: toDateTimeLocalInput(payload.start_time),
  [FORM_FIELDS.ALERT_ON_SUCCESS]: payload.success_alert_enabled,
  [FORM_FIELDS.ALERT_ON_FAILURE]: payload.failure_alert_enabled,
})
